import React, { useEffect, useMemo, useReducer, useState } from 'react';
import moment from 'moment-timezone/builds/moment-timezone-with-data-10-year-range.js';
import Icon from 'components/ui/Icon';
import Modal from 'portal/Modal';
import { modalReducer, modalInitialState } from 'helper/modalReducer';
import setting from 'helper/setting';
import log from 'helper/log';
import { ReactComponent as WhatsAppButton } from 'images/whatsapp-button.svg';
import { ReactComponent as WhatsAppQR } from 'images/whatsapp-qr.svg';

let interval;

const WhatsApp = (props) => {
    const [modal, dispatchModal] = useReducer(modalReducer, modalInitialState);
    const phoneNumber = '443300416642'; // Hard coded for now
    const whatsAppTimeout = setting.get('whatsApp.interval', setting.get('liveChat.interval', 60)); // Seconds before checking for Live chat

    const activeTimes = useMemo(() => {
        let tmpActiveTimes = {
            mon: null,
            tue: null,
            wed: null,
            thu: null,
            fri: null,
            sat: null,
            sun: null,
        }
        Object.keys(tmpActiveTimes).forEach(day => {
            const times = setting.get('whatsApp.activeTime' + day[0].toUpperCase() + day.substring(1), null);
            if (times) {
                const splitTimes = times.split('-');
                tmpActiveTimes[day] = {
                    start: moment.tz(splitTimes[0], 'HH:mm', true, 'Europe/London'),
                    end:   moment.tz(splitTimes[1], 'HH:mm', true, 'Europe/London'),
                }
            } else {
                tmpActiveTimes[day] = null;
            }
        });
        return tmpActiveTimes;
    }, []);

    const whatsAppUrl = phoneNumber ? 'https://api.whatsapp.com/send/?phone=' + phoneNumber : null;
    const [whatsAppTimeoutDone, setWhatsAppTimeoutDone] = useState(false);
    const [showButton, setShowButton] = useState(false);
    useEffect(() => {
        clearInterval(interval);
        if (whatsAppTimeout > 0 && phoneNumber && props.authorised) {
            interval = setTimeout(() => {
                setWhatsAppTimeoutDone(true);
            }, whatsAppTimeout * 1000);
        } else if (whatsAppTimeoutDone) {
            setWhatsAppTimeoutDone(false);
        }
        return () => {
            clearInterval(interval);
        }
    }, [props.authorised, phoneNumber, whatsAppTimeout, whatsAppTimeoutDone]);
    useEffect(() => {
        const interval = setInterval(() => {
            const currentDay = moment.tz('Europe/London').format('ddd').toLowerCase();
            setShowButton(
                whatsAppTimeoutDone
                && props.authorised
                && activeTimes[currentDay]
                && moment.tz('Europe/London').isSameOrAfter(activeTimes[currentDay].start, 'minute')
                && moment.tz('Europe/London').isBefore(activeTimes[currentDay].end, 'minute')
            );
        }, 15000);
        return () => {
            clearInterval(interval);
        }
    }, [props.authorised, whatsAppTimeoutDone, activeTimes]);

    const openLiveChat = (e) => {
        e?.preventDefault();
        if (showButton) {
            const width = 600;
            const height = 600;
            const left = (window.screen.width / 2) - (width / 2);
            const top = (window.screen.height / 2) - (height / 2);
            log.action('Live chat', 'Opened WhatsApp chat', 'live_chat_whatsapp_chat');
            window.open(whatsAppUrl, 'whatsappChat', 'scrollbars=yes, width=' + width + ', height=' + height + ', top=' + top + ', left=' + left);
        }
    }
    const openModal = () => {
        if (window.getComputedStyle(document.querySelector('.live-chat--whatsapp')).getPropertyValue('--whatsapp-modal') === 'bypass') {
            openLiveChat();
        } else {
            dispatchModal({
                type: 'open',
                content: <div className="whatsapp-modal">
                    <div className="whatsapp-modal__col whatsapp-modal__col--device">
                        <h3>On a device with WhatsApp?</h3>
                        <div className="whatsapp-modal__button-container"><a href={ whatsAppUrl } onClick={ openLiveChat } title="Chat on WhatsApp" target="_blank" rel="noreferrer noopener external"><WhatsAppButton/></a></div>
                        <p>If you have WhatsApp installed on this device, click the button to start a new chat.</p>
                    </div>
                    <div className="whatsapp-modal__col whatsapp-modal__col--scan">
                        <h3>Have WhatsApp on your phone?</h3>
                        <WhatsAppQR className="whatsapp-modal__qr"/>
                        <p>Scan the above code with your phone camera.</p>
                    </div>
                </div>
            });
            log.action('Live chat', 'Opened WhatsApp modal', 'live_chat_whatsapp_modal');
        }
    }
    if (!phoneNumber || !props.authorised) {
        clearInterval(interval);
        return null;
    }
    return showButton && (<>
        <div className="live-chat live-chat--whatsapp">
            <button className="live-chat__button" onClick={ openModal }><span className="live-chat__button-inner"><Icon icon="WhatsApp"/>WhatsApp</span></button>
        </div>
        <Modal { ...modal } dispatchModal={ dispatchModal }>{ modal.content }</Modal>
    </>)
}

export default WhatsApp;